import { createAsyncThunk } from '@reduxjs/toolkit';

import { IThunkApi } from 'shared/types/redux';
import { IValidateAddressWebRequest } from 'shared/repositories/price-estimator/v1/validate-address-web';
import { fetchValidateAdress } from 'shared/services/fetchValidateAdress';
import { ACCEPTED_REGIONS_VALUE, MOSCOW_REGIONS } from 'shared/constants/regions';
import { setAddress, setModalStatus, setPriceRange, setStep } from 'shared/slices';
import { PRICE_RANGE } from 'shared/constants/price';
import { EModalStatus } from 'shared/types/modal';

export const validateAddress = createAsyncThunk<string | undefined, IValidateAddressWebRequest, IThunkApi>(
  'form/validateAdress',
  async (params, thunkApi) => {
    const { rejectWithValue, extra, dispatch } = thunkApi;

    try {
      const { statusCode, response } = await fetchValidateAdress(extra, params);

      if (statusCode === 200) {
        let regionFinded: string | undefined;

        ACCEPTED_REGIONS_VALUE.map(region => {
          if (params.address.includes(region)) {
            regionFinded = region;
          }
        });

        if (!regionFinded) {
          dispatch(
            setModalStatus({
              status: EModalStatus.Failed,
              error: {
                title: 'К сожалению, не сможем помочь',
                description:
                  'Сервис не работает в вашем регионе. Вы можете разместить объявление о сдаче на Циан самостоятельно',
              },
            }),
          );
        } else {
          const priceRange: [number, number] = MOSCOW_REGIONS.includes(regionFinded) ? PRICE_RANGE[0] : PRICE_RANGE[1];

          dispatch(setPriceRange(priceRange));

          dispatch(setAddress(params.address));

          dispatch(setStep(1));
        }

        return;
      }

      return rejectWithValue(response.message);
    } catch (e) {
      extra.logger.error(e);

      return rejectWithValue('Что-то пошло не так');
    }
  },
);
